import { IPreviewTariff, } from 'atlas-shared';
import { ITariffStore, TariffActions, TTariffActionTypes, } from '@Store';

export const TariffReducer = (state: ITariffStore = {
  loaded: false,
  loading: false,
  tariffs: [],
  dict: {},
}, action: TTariffActionTypes): ITariffStore => {
  switch (action.type) {
  case TariffActions.LOADING:
    return { ...state, loading: true, };
  case TariffActions.SET_STATE:
    const dict: ITariffStore['dict'] = {};

    action.payload.forEach((tariff: IPreviewTariff) => dict[tariff.id] = tariff);

    return { ...state, loaded: true, loading: false, tariffs: action.payload, dict, };
  case TariffActions.ADD_STATE:
    return { ...state, tariffs: [...state.tariffs, action.payload, ], dict: { ...state.dict, [action.payload.id]: action.payload, }, };
  case TariffActions.REMOVE_STATE: {

    const { [action.payload]: _deleted, ...dict } = state.dict;

    return { ...state, tariffs: state.tariffs.filter((item: IPreviewTariff) => item.id !== action.payload), dict, };
  }
  case TariffActions.UPDATE_STATE:
    const tariffs = [...state.tariffs, ];
    const index = state.tariffs.findIndex((tariff: IPreviewTariff) => tariff.id === action.payload.id);

    if (!~index)
      tariffs.push(action.payload);
    else
      tariffs[index] = action.payload;

    return { ...state, tariffs, dict: { ...state.dict, [action.payload.id]: action.payload, }, };
  default:
    return state;
  }
};
